import { useMemo } from 'react'

import ProductTag from '@src/quince-site-common/src/domains/ProductTag'

import { CardVariant, ProductCardTag } from './product-card.types'
export function useRefreshedTags(
  cardVariants: CardVariant[],
  selectedVariant?: CardVariant,
  refreshedProductTags?: ProductTag[],
) {
  const tagsToColorMap = useMemo(() => {
    const _tagsToColorMap = new Map<string, ProductCardTag[]>()
    if (refreshedProductTags) {
      cardVariants.forEach(cardVariant => {
        const tags: ProductCardTag[] = refreshedProductTags
          .filter(tag => {
            if (!tag.options.length) return true
            return tag.options.some(tagOption => tagOption.value === cardVariant.displayConfig.value)
          })
          .map(tag => ({ value: tag.value, tagType: tag.tagType, displayName: tag.displayName }))
        _tagsToColorMap.set(cardVariant.displayConfig.value, tags)
      })
    }
    return _tagsToColorMap
  }, [refreshedProductTags, cardVariants])

  return selectedVariant?.displayConfig.value ? tagsToColorMap.get(selectedVariant.displayConfig.value) : undefined
}
